module.exports = __webpack_public_path__ + "img/v_print.deb66f18.svg";